// extracted by mini-css-extract-plugin
export default {"hidden":"Detail_hidden__-mXEw","monospace":"Detail_monospace__mXwps","wFull":"Detail_wFull__MGTEE","ellipsis":"Detail_ellipsis__Pp8uI","container":"Detail_container__j8vo4"};